import React, { Fragment } from "react";
import DialogContent from "@mui/material/DialogContent";

import DialogHeader from "~/components/Modal/ShowMaterialModal/DialogHeader";
import DialogFooter from "~/components/Modal/ShowMaterialModal/DialogFooter";
import MaterialRenderer from "~/components/MaterialRenderer";

import { materialType } from "~/constants/prop-types";
import PropTypes from "prop-types";

function MaterialRendererModal({ material, kind }) {
  return (
    <>
      <DialogHeader id={`${kind}-modal-title`} title={material.title || material.name} isCloseableOnly={true} />
      <DialogContent>
        <MaterialRenderer {...material} />
      </DialogContent>
      <DialogFooter isEditMode={false} />
    </>
  );
}

MaterialRendererModal.propTypes = {
  material: materialType,
  kind: PropTypes.string.isRequired
};

export default MaterialRendererModal;
